export enum StudentPlanningTypeEnum {
    CreatePlan = 1,
    UpdatePlan = 2,
    DeletePlan = 3
}